import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, Send } from "lucide-react";
import Navbar from "@/components/marketing/Navbar.jsx";
import Footer from "@/components/marketing/Footer.jsx";
import api from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks! We'll get back within 24 hours.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (e) { toast.error("Failed. Try again."); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <section className="pt-16 pb-24 bg-mesh">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 text-center">
          <div className="text-xs uppercase tracking-widest font-semibold text-brand-purple">Contact</div>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-brand-navy">Let's talk.</h1>
          <p className="mt-4 text-brand-muted">Have a Team plan question? Partnership? Press? Drop us a note.</p>
        </div>
      </section>
      <section className="-mt-12 pb-24">
        <div className="max-w-2xl mx-auto px-5 lg:px-8">
          <form onSubmit={submit} className="bg-white rounded-3xl border border-brand-borderc p-7 shadow-soft space-y-3">
            <div className="grid md:grid-cols-2 gap-3">
              <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" className="px-3 py-2.5 rounded-xl border border-brand-borderc focus:border-brand-purple outline-none" />
              <input data-testid="contact-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="px-3 py-2.5 rounded-xl border border-brand-borderc focus:border-brand-purple outline-none" />
            </div>
            <input data-testid="contact-subject" required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="Subject" className="w-full px-3 py-2.5 rounded-xl border border-brand-borderc focus:border-brand-purple outline-none" />
            <textarea data-testid="contact-message" required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Tell us what you need" className="w-full px-3 py-2.5 rounded-xl border border-brand-borderc focus:border-brand-purple outline-none resize-none" />
            <button data-testid="contact-submit-btn" disabled={busy} className="btn-primary-gradient rounded-full px-6 py-3 font-semibold inline-flex items-center gap-2">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
              Send message
            </button>
          </form>
          <div className="mt-6 flex items-center gap-2 justify-center text-sm text-brand-muted">
            <Mail className="w-4 h-4" /> hello@draftvoice.ai
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
